
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { WaitEntre } from '@/__env/ext';
import { Viajante, EstadisticaVentas } from '@/__env/lib/Ventas/Viajantes';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: string = '';

        @Prop( { type: Viajante } )
        public Viajante: Viajante;
        @Watch( 'Viajante', { immediate: true } )
        onEmpresa()
        {
            this.buscar();
        }

        public Item: EstadisticaVentas = new EstadisticaVentas();
        async buscar()
        {

            await WaitEntre( 500, 1000 );
            this.Item = await EstadisticaVentas.actual( this.Viajante );
            this.Estado = 'ok';
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }


    }
